import CryptoJS from "crypto-js"

window._use = window._use || {}
var use =
  process.env.NODE_ENV == "production"
    ? window._use.usep
    : process.env.NODE_ENV == "test"
      ? window._use.used
      : window._use.used
var use1 = CryptoJS.enc.Utf8.parse(use)
var use2 = CryptoJS.enc.Utf8.parse(use)


export function getDAesString (encrypted) {
  var decrypted = CryptoJS.AES.decrypt(encrypted, use1,
    {
      use2: use2,
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    })
  return decrypted.toString(CryptoJS.enc.Utf8)
}


// WEBPACK FOOTER //
// ./src/utils/encryp.js